import { DirectiveBinding } from 'vue/types/options.d';
import { operate } from './log';

export default {
  install(instance: any, options = { name: 'log' }) {
    /* eslint-disable no-param-reassign */
    instance.prototype.$log = operate;

    instance.directive(options.name, {
      inserted(el: HTMLElement, binding: DirectiveBinding) {
        el.addEventListener('click', () => {
          operate({
            title: binding.value.name,
            component: binding.value.component,
          });
        });
      },
    });
  },
};
